/**
 * The catalogs the scheduler picks from: the rolling windows a scheduled
 * report can cover, and the timezones offered for a send time.
 *
 * Shared by the drawer that writes them and the subscriptions list that reads
 * them back, so the two never disagree about what "last3" means. The values
 * are the contract with azfApi's reportSubscriptionRunner.
 */
export const PERIODS = [
    { value: 'currentView', label: 'Use this view’s date range' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: 'mtd', label: 'Month to date' },
    { value: 'lastMonth', label: 'Last month' },
    { value: 'last7', label: 'Last 7 days' },
    { value: 'last3', label: 'MTD + last 3 months' },
    { value: 'ytd', label: 'Year to date' },
    // Forward-looking windows (same presets as the Revenue Forecast page)
    { value: 'thisMonth', label: 'This month (actuals + on-the-books)' },
    { value: 'next30', label: 'Next 30 days' },
    { value: 'nextMonth', label: 'Next month' },
    { value: 'next90', label: 'Next 90 days' },
    { value: 'throughYearEnd', label: 'Through year end' },
];

/** The label for a stored period value, or the value itself if it is unknown. */
export const periodLabel = (value) => (PERIODS.find((item) => item.value === value) || {}).label || value || '';

/**
 * Timezones offered in the schedule picker, ahead of the viewer's own.
 * Not exhaustive by design — a schedule keeps whatever zone it was saved with.
 */
export const COMMON_TIMEZONES = [
    'America/New_York', 'America/Chicago', 'America/Denver', 'America/Phoenix',
    'America/Los_Angeles', 'America/Anchorage', 'Pacific/Honolulu', 'UTC',
];

/** The picker's list, led by the zones passed in (a saved schedule's, the viewer's). */
export const timezoneChoices = (...current) => [...new Set([...current, ...COMMON_TIMEZONES].filter(Boolean))];
